import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const updateProfile = createAsyncThunk('updateProfile/updateProfile', async (data) => {
    const { name,contact, date_of_birth, password } = data;
    try {
        const res = await axios({
            method: 'put',
            url: process.env.REACT_APP_API_URL + `update_profile_password/${localStorage.getItem("id")}`,
            data: {
                name:name,
                phone: contact,
                dob: date_of_birth,
                password: password
            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }
        })
        return res
    } catch (error) {
        return error.response
    }
})

